export const ROLES = {
    SuperUser: 'SuperUser',
    CompanyAdmin: 'CompanyAdmin',
    CompanyUser: 'CompanyUser',
    CompanySupervisor: 'CompanySupervisor',
    TradesPerson: 'TradesPerson',
    Unregistered: 'Unregistered',
}
